export default interface platformMajPictureZoomDto {
    id: string;
    length: number;
    distance: number;
    fileFormat: string;
    backColor: string;
    minSizeFrame: any;
    title: string;
    description: string;
    logo: string;
}



const date1 = new Date();
const date2 = new Date(2013, 11, 22);
const diff = new Date(date1.getTime() - date2.getTime());

export const homeGhajari3AboutTemplate: platformMajPictureZoomDto =

{
    id: "AboutMeWallpaper",
    fileFormat: '.jpg',
    length: 20,
    distance: 100,
    backColor: 'var(--backColor)',
    minSizeFrame: { width: 300, height: 300 },
    title: "",
    description:
        `<h3><b>OBJECTIVE</b></h3>
            <p>
Dedicated web developer with over 10 years of experience in designing and implementing innovative, scalable web applications. Proficient in leveraging technologies such as React, ASP.NET, and modern frameworks to deliver high-quality solutions that enhance user experiences. Committed to best practices in both backend and frontend development, with a strong focus on building responsive and efficient applications. Seeking a position that allows me to contribute my expertise in a collaborative environment, where I can work alongside a talented team to create impactful software solutions that meet client needs and drive business success. Eager to embrace new challenges and continuously improve my skills in a dynamic work setting.
            </p>
            `,
    logo: "AboutMeLogo.png"
}